module.exports = __webpack_public_path__ + "assets/img/solution_top.2a917280.png";